/* KC homepage variants. The existing kameo-d-base.js owns the number animation. */
(function () {
  'use strict';
  if (window.__kameoHomeFlow) return;
  window.__kameoHomeFlow = true;

  function init(scope) {
    scope.querySelectorAll('[data-khf-slider]').forEach(function (slider) {
      if (slider.dataset.khfReady) return;
      slider.dataset.khfReady = 'true';
      var slides = Array.from(slider.querySelectorAll('[data-khf-slide]'));
      if (!slides.length) return;
      var prev = slider.querySelector('[data-khf-prev]');
      var next = slider.querySelector('[data-khf-next]');
      var status = slider.querySelector('[data-khf-status]');
      var wide = window.matchMedia('(min-width: 1101px)');
      var index = 0, visible = wide.matches ? 2 : 1, startX = null, startY = null;
      function show(target) {
        var pages = Math.ceil(slides.length / visible);
        var page = ((Math.floor(target / visible) % pages) + pages) % pages;
        index = page * visible;
        var end = Math.min(index + visible, slides.length);
        slides.forEach(function (slide, n) { slide.hidden = n < index || n >= end; });
        status.textContent = String(index + 1).padStart(2, '0') + (end > index + 1 ? '–' + String(end).padStart(2, '0') : '') + ' / ' + slides.length;
        status.setAttribute('aria-label', (end > index + 1 ? 'Reviews ' + (index + 1) + ' tot ' + end : 'Review ' + (index + 1)) + ' van ' + slides.length);
        slider.dataset.khfIndex = String(index);
        prev.hidden = next.hidden = slides.length <= visible;
      }
      prev.addEventListener('click', function () { show(index - visible); });
      next.addEventListener('click', function () { show(index + visible); });
      slider.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? visible : -visible));
        }
      });
      slider.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].clientX;
        startY = event.changedTouches[0].clientY;
      }, { passive: true });
      slider.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? visible : -visible));
        startX = startY = null;
      }, { passive: true });
      wide.addEventListener('change', function () {
        visible = wide.matches ? 2 : 1;
        show(index);
      });
      slider.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest('[data-khf-slide]');
        if (slide) show(slides.indexOf(slide));
      });
      show(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
